import state from './state'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

export default {
  state,
  getters,
  actions,
  mutations
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/ui/index.js
// module id = null
// module chunks = 